import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { Icon4gPlusPlusProps } from './Icon4gPlusPlus.types'
import * as Styled from './styles/Icon4gPlusPlus.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon4gPlusPlus: FC<Icon4gPlusPlusProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon4gPlusPlusProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: Icon4gPlusPlusProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M11.355 12.137h1.52v1.3c.016.477-.3.903-.758 1.028-.898.25-2.71.406-2.71-2.543 0-3.195 2.874-2.809 3.304-2'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M21.477 12.04c0 5.245-4.254 9.5-9.5 9.5-5.247 0-9.5-4.255-9.5-9.5 0-5.25 4.253-9.5 9.5-9.5h9.5ZM7.129 9.457v5.191'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M7.996 13.133H4.312L7.13 9.457M14.25 12h2m-1-1v2m2.488-1h2m-1-1v2' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default Icon4gPlusPlus
